var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { openSharePanel, ShareChannel, shareLinkByAllChannel, shareImage } from '@tencent/vb-app-bridge';
import html2canvas from 'html2canvas';
import { ShareResultCode } from './types';
import { DefaultShareLinkChannelList, NoPicPermissionErrorMessage, DefaultImageLinkChannelList, DefaultErrorMessage, DefaultShareLinkAndImageChannelList, } from './config';
import { t } from './locales/index';
import { getLang } from '../i18n';
import { isFusionBankApp, isWeChat } from '@tencent/vb-web-base-core';
import { wxBridge } from '../weixin';
import { toast } from '@tencent/web-vbui/src/components/t-toast/toast';
/**
 * 异常处理
 * 可能来自两个接口的异常：A. 打开面板 B. 拉起渠道分享，各个接口均有可能有两种可预知的异常
 * A openSharePanel
 * 1. 调用服务报错；{code:,type:,result:{code:,type:,message?:,data:{...}}} ---> 极小概率，不用细究
 * 2. 服务调用成功，但是拉起面板报错；{code:,type:,result:{channel:不一定有哦,result:,msg:,}}
 * B shareLinkByAllChannel\shareImage
 * 1. 调用app的分享能力成功，但分享本身异常； ==> 细分处理，特别是对用户主动取消的分享异常需要不做响应，其余直接toast msg
 * {code:,type:,result:{code:,type:,message?:,data:{...}}}---> 极小概率，不用细究
 * 2. 调用app的分享能力异常；==> 报一个系统异常即可
 * {code:,type:,result:{channel:不一定有哦,result:,msg:,}}
 * 基于上述对异常类型的分析，【结论】尽量简化调用方，将异常信息返回给业务方自行提示，错误码逻辑拍板（不重要）
 * @param error
 * @returns
 */
var shareByAppErrorHandler = function (error) { return __awaiter(void 0, void 0, void 0, function () {
    var lang, errorResult;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getLang()];
            case 1:
                lang = _a.sent();
                if (error.code === '0') {
                    errorResult = error.result;
                    if (errorResult === null || errorResult === void 0 ? void 0 : errorResult.result) {
                        // 取消分享等同于中断操作，业务侧不做任何处理
                        if (errorResult.result === ShareResultCode.CANCEL)
                            return [2 /*return*/];
                        if (errorResult.result === ShareResultCode.NOT_PIC_PERMISSION) {
                            return [2 /*return*/, {
                                    code: parseInt(errorResult.result, 10),
                                    message: t(NoPicPermissionErrorMessage, lang),
                                    channel: errorResult.channel,
                                }];
                        }
                        return [2 /*return*/, {
                                code: parseInt(errorResult.result, 10),
                                message: errorResult.msg || t(DefaultErrorMessage, lang),
                                channel: errorResult.channel,
                            }];
                    }
                }
                return [2 /*return*/, {
                        code: parseInt(error.code || -1, 10),
                        message: t(DefaultErrorMessage, lang),
                    }];
        }
    });
}); };
/**
 * 分享链接（app内）
 * @param options
 * @returns
 */
export var shareByLinkInApp = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var channelList, shareParams, channel, res, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 4, , 6]);
                channelList = options.channelList, shareParams = options.shareParams;
                return [4 /*yield*/, openSharePanel(channelList || DefaultShareLinkChannelList)];
            case 1:
                channel = _a.sent();
                if (!(channel !== ShareChannel.UNKNOWN)) return [3 /*break*/, 3];
                return [4 /*yield*/, shareLinkByAllChannel(channel, shareParams)];
            case 2:
                res = _a.sent();
                console.log('shareByLink res', res);
                return [2 /*return*/, {
                        code: parseInt(res.result, 10),
                        message: res.msg,
                        channel: res.channel,
                    }];
            case 3: return [3 /*break*/, 6];
            case 4:
                error_1 = _a.sent();
                console.log('shareByLink error', error_1);
                return [4 /*yield*/, shareByAppErrorHandler(error_1)];
            case 5: return [2 /*return*/, _a.sent()];
            case 6: return [2 /*return*/];
        }
    });
}); };
/**
 * 分享图片（app内）
 * @param options
 * @returns
 */
export var shareByImageInApp = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var channelList, shareRef, channel, canvas, data, res, error_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 5, , 7]);
                channelList = options.channelList, shareRef = options.shareRef;
                return [4 /*yield*/, openSharePanel(channelList || DefaultImageLinkChannelList)];
            case 1:
                channel = _a.sent();
                if (!(channel !== ShareChannel.UNKNOWN)) return [3 /*break*/, 4];
                return [4 /*yield*/, html2canvas(shareRef.value, {
                        useCORS: true,
                        allowTaint: false,
                        scale: 3,
                    })];
            case 2:
                canvas = _a.sent();
                data = canvas.toDataURL();
                return [4 /*yield*/, shareImage(channel, {
                        imagePath: data,
                    })];
            case 3:
                res = _a.sent();
                console.log('shareByImage res', res);
                return [2 /*return*/, {
                        code: parseInt(res.result, 10),
                        message: res.msg,
                        channel: res.channel,
                    }];
            case 4: return [3 /*break*/, 7];
            case 5:
                error_2 = _a.sent();
                console.log('shareByImage error', error_2);
                return [4 /*yield*/, shareByAppErrorHandler(error_2)];
            case 6: return [2 /*return*/, _a.sent()];
            case 7: return [2 /*return*/];
        }
    });
}); };
// 分享链接（微信内）
export var shareByLinkInWx = function () {
    // TODO 弹出微信分享引导浮层（会和ui组件产生循环依赖，需要等底层仓库重构再实现）
    console.warn('微信分享引导浮层暂不支持');
};
/**
 * 分享信息
 */
var shareInfo = null;
/**
 * 设置分享文案
 * @param params
 */
export var setShareInfo = function (params) {
    shareInfo = params;
    if (isWeChat) {
        wxBridge.setShareInfo({
            title: shareInfo.wxTitle,
            desc: shareInfo.wxDesc,
            link: shareInfo.link,
            imgUrl: shareInfo.wxThumbPath,
        });
    }
};
/**
 * 分享链接（用户触发）
 */
export var shareLink = function () { return __awaiter(void 0, void 0, void 0, function () {
    var res;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!shareInfo) {
                    throw new Error('Please set share info before share');
                }
                if (!isFusionBankApp) return [3 /*break*/, 2];
                return [4 /*yield*/, shareByLinkInApp({ shareParams: shareInfo })];
            case 1:
                res = _a.sent();
                if (res) {
                    toast.show({
                        title: res.message,
                        timeout: 2000,
                    });
                }
                _a.label = 2;
            case 2:
                if (isWeChat) {
                    shareByLinkInWx();
                }
                return [2 /*return*/];
        }
    });
}); };
/**
 * App内同时分享图片和链接
 * @param options
 * @returns
 */
export var shareByLinkAndImageInApp = function (options) { return __awaiter(void 0, void 0, void 0, function () {
    var channelList, shareParams, shareRef, channel, canvas, data, res_1, res, error_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 6, , 8]);
                channelList = options.channelList, shareParams = options.shareParams, shareRef = options.shareRef;
                return [4 /*yield*/, openSharePanel(channelList || DefaultShareLinkAndImageChannelList)];
            case 1:
                channel = _a.sent();
                if (channel === ShareChannel.UNKNOWN)
                    return [2 /*return*/];
                if (!(channel === ShareChannel.SAVE_PICTURE)) return [3 /*break*/, 4];
                return [4 /*yield*/, html2canvas(shareRef.value, {
                        useCORS: true,
                        allowTaint: false,
                        scale: 3,
                    })];
            case 2:
                canvas = _a.sent();
                data = canvas.toDataURL();
                return [4 /*yield*/, shareImage(channel, {
                        imagePath: data,
                    })];
            case 3:
                res_1 = _a.sent();
                console.log('shareByImage res', res_1);
                return [2 /*return*/, {
                        code: parseInt(res_1.result, 10),
                        message: res_1.msg,
                        channel: res_1.channel,
                    }];
            case 4: return [4 /*yield*/, shareLinkByAllChannel(channel, shareParams)];
            case 5:
                res = _a.sent();
                console.log('shareByLink res', res);
                return [2 /*return*/, {
                        code: parseInt(res.result, 10),
                        message: res.msg,
                        channel: res.channel,
                    }];
            case 6:
                error_3 = _a.sent();
                console.log('shareInApp error', error_3);
                return [4 /*yield*/, shareByAppErrorHandler(error_3)];
            case 7: return [2 /*return*/, _a.sent()];
            case 8: return [2 /*return*/];
        }
    });
}); };
